import { api } from "./client";

export function getPartnerReferrals(page = 1, { signal } = {}) {
  return api(`/api/account/partner-referrals?page=${encodeURIComponent(page)}&limit=20`, { signal });
}
